import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

export const get = (uuid=null) => async (dispatch) => {
    try {
        const res = await api.get(`/payroll/schedules/${isGuid(uuid) ? ("i/" + uuid) : ""}`);
        return isGuid(uuid) ? res.data : res.data?.items;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const search = ({ search = "", page = 0, size = 25, order = "name", direction = "DESC" } = {}) => async (dispatch) => {
    try {
        const term = (search == null || String(search).trim() === "") ? "*" : String(search).trim();
        const enc = encodeURIComponent(term);
        const url = `/payroll/schedules/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}/${enc}`;
        const res = await api.get(url);
        return res.data;
    } catch (err) {
        dispatch({ type: LOGOUT });
    }
};


export const save = (payload = {}) => async (dispatch) => {
    try {
        const res = await api.post(`/payroll/schedules`, payload);
        return res.data;
    } catch (err) {
        dispatch({ type: LOGOUT });
    }
};

export const destroy = (uuid = null) => async (dispatch) => {
    try {
        if (!isGuid(uuid)) return;
        const res = await api.delete(`/payroll/schedules/i/${uuid}`);
        return res.data;
    } catch (err) {
        dispatch({ type: LOGOUT });
    }
};
